import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

interface CopySharedWorkflowProps {
  handleCopySharedWorkflow: () => void;
}

export const CopySharedWorkflow = ({
  handleCopySharedWorkflow,
}: CopySharedWorkflowProps) => {
  const [showPopupMsg, setShowPopupMsg] = useState(true);
  const handleClosePopupMsg = () => setShowPopupMsg(false);

  return (
    <Box className="copy-workflow-popup">
      <Box
        className="copy-workflow-popup-msg"
        sx={{ display: showPopupMsg ? "flex" : "none" }}
      >
        <Box>
          <Typography className="popup-msg-head">
            Create same workflow{" "}
          </Typography>
          <Typography>
            You’ll get the exact same setup, ready to edit or run.
          </Typography>
        </Box>
        <Box className="close-popup-msg" onClick={handleClosePopupMsg}>
          Close
        </Box>
      </Box>
      <Box
        className="copy-workflow-popup-button"
        onClick={handleCopySharedWorkflow}
      >
        <Typography>Copy workflow</Typography>
        <ArrowForwardIcon />
      </Box>
    </Box>
  );
};
